import type { Deal, PipelineStage } from "../types";

/** Deals of one pipeline by stage id (as a string: the droppable id). */
export type DealsByStage = Record<string, Deal[]>;

export const getDealsByStage = (
  unorderedDeals: Deal[],
  stages: PipelineStage[],
): DealsByStage => {
  if (!stages.length) return {};
  const dealsByStage: DealsByStage = Object.fromEntries(
    stages.map((stage) => [String(stage.id), [] as Deal[]]),
  );
  for (const deal of unorderedDeals) {
    // a deal on a stage that is not in this pipeline goes to the first stage
    const key = String(deal.stage_id);
    (dealsByStage[key] ?? dealsByStage[String(stages[0].id)]).push(deal);
  }
  // order each column by index
  for (const key of Object.keys(dealsByStage)) {
    dealsByStage[key].sort((a, b) => a.index - b.index);
  }
  return dealsByStage;
};

/** where a new deal starts: the first «в работе» stage of its pipeline */
export const firstOpenStage = (stages: PipelineStage[]) =>
  stages.find((s) => s.outcome === "open") ?? stages[0];
